import { Card } from "../../../components/Card";
import type { ChangeHistoryEntry } from "../types";

function formatTimestamp(ts: string): string {
  return new Date(ts).toLocaleString("en-US", {
    timeZone: "America/New_York",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

function formatChanges(changes: ChangeHistoryEntry["changes"]): string {
  if (!changes) return "";
  return Object.entries(changes)
    .map(([key, val]) => {
      if (val && typeof val === "object" && "old" in val) {
        return `${key}: ${String(val.old)} → ${String(val.new)}`;
      }
      return `${key}: ${String(val)}`;
    })
    .join(", ");
}

export function HistoryCard({
  history,
}: {
  history: ChangeHistoryEntry[];
  userId: string;
}) {
  return (
    <Card className="!p-6">
      <h3 className="text-base font-semibold text-content-primary mb-4">
        Change History
      </h3>

      {history.length === 0 ? (
        <p className="text-sm text-content-tertiary py-4 text-center">
          No changes recorded
        </p>
      ) : (
        <div className="max-h-[400px] overflow-auto flex flex-col gap-2">
          {history.map((entry) => (
            <div
              key={entry.id}
              className="px-3 py-2.5 border border-border-secondary rounded-lg"
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs text-content-tertiary">
                  {formatTimestamp(entry.timestamp)}
                </span>
                <span className="text-xs px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded font-medium">
                  {entry.trigger}
                </span>
              </div>
              {entry.reasoning && (
                <p className="text-sm text-content-secondary mb-1">
                  {entry.reasoning}
                </p>
              )}
              <p className="text-xs text-content-tertiary truncate">
                {formatChanges(entry.changes)}
              </p>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
